import { __rest } from "tslib";
import React, { Children, forwardRef, useContext } from 'react';
import classNames from 'classnames';
import { ListContext } from './index';
import { Col } from '../grid';
import { ConfigContext } from '../config-provider';
import { cloneElement } from '../_util/reactNode';
export const Meta = (_a) => {
    var { prefixCls: customizePrefixCls, className, avatar, title, description } = _a, others = __rest(_a, ["prefixCls", "className", "avatar", "title", "description"]);
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    const classString = classNames(`${prefixCls}-item-meta`, className);
    const content = (React.createElement("div", { className: `${prefixCls}-item-meta-content` },
        title && React.createElement("h4", { className: `${prefixCls}-item-meta-title` }, title),
        description && React.createElement("div", { className: `${prefixCls}-item-meta-description` }, description)));
    return (React.createElement("div", Object.assign({}, others, { className: classString }),
        avatar && React.createElement("div", { className: `${prefixCls}-item-meta-avatar` }, avatar),
        (title || description) && content));
};
const InternalItem = (_a, ref) => {
    var { prefixCls: customizePrefixCls, children, actions, extra, className, colStyle } = _a, others = __rest(_a, ["prefixCls", "children", "actions", "extra", "className", "colStyle"]);
    const { grid, itemLayout } = useContext(ListContext);
    const { getPrefixCls } = useContext(ConfigContext);
    const isItemContainsTextNodeAndNotSingular = () => {
        let result;
        Children.forEach(children, (element) => {
            if (typeof element === 'string') {
                result = true;
            }
        });
        return result && Children.count(children) > 1;
    };
    const isFlexMode = () => {
        if (itemLayout === 'vertical') {
            return !!extra;
        }
        return !isItemContainsTextNodeAndNotSingular();
    };
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    const actionsContent = actions && actions.length > 0 && (React.createElement("ul", { className: `${prefixCls}-item-action`, key: "actions" }, actions.map((action, i) => (
    // eslint-disable-next-line react/no-array-index-key
    React.createElement("li", { key: `${prefixCls}-item-action-${i}` },
        action,
        i !== actions.length - 1 && React.createElement("em", { className: `${prefixCls}-item-action-split` }))))));
    const Element = grid ? 'div' : 'li';
    const itemChildren = (React.createElement(Element, Object.assign({}, others, (!grid ? { ref } : {}), { className: classNames(`${prefixCls}-item`, {
            [`${prefixCls}-item-no-flex`]: !isFlexMode(),
        }, className) }), itemLayout === 'vertical' && extra
        ? [
            React.createElement("div", { className: `${prefixCls}-item-main`, key: "content" },
                children,
                actionsContent),
            React.createElement("div", { className: `${prefixCls}-item-extra`, key: "extra" }, extra),
        ]
        : [children, actionsContent, cloneElement(extra, { key: 'extra' })]));
    return grid ? (React.createElement(Col, { ref: ref, flex: 1, style: colStyle }, itemChildren)) : (itemChildren);
};
const Item = forwardRef(InternalItem);
Item.Meta = Meta;
export default Item;
